import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

import { PaziaCheckbox, PaziaFormButton, PaziaInput } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { ShopRedirectApi } from "api/shop";

interface ShopRedirectModalProps {
  onCloseRequest: () => void;
  isOpen: boolean;
  redirect?: ShopRedirectApi | null;
  defaults?: Partial<ShopRedirectFormValues>;
  onSubmit: (data: ShopRedirectFormValues) => Promise<void>;
}

export const ShopRedirectModal = ({ onCloseRequest, isOpen, redirect, defaults, onSubmit }: ShopRedirectModalProps) => {
  return (
    <PaziaModal
      id="shop-redirect-modal"
      onCloseRequest={onCloseRequest}
      isOpen={isOpen}
      size="lg"
    >
      {isOpen && (
        <ModalPadding>
          <ModalHeader>{redirect ? "Edytuj przekierowanie" : "Dodaj przekierowanie"}</ModalHeader>
          <ShopRedirectForm onSubmit={onSubmit} redirect={redirect} defaults={defaults} />
        </ModalPadding>
      )}
    </PaziaModal>
  );
};

interface ShopRedirectFormProps {
  onSubmit: (data: ShopRedirectFormValues) => Promise<void>;
  redirect?: ShopRedirectApi | null;
  defaults?: Partial<ShopRedirectFormValues>;
}

const ShopRedirectForm = ({ onSubmit, redirect, defaults }: ShopRedirectFormProps) => {
  const methods = useForm<ShopRedirectFormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      sourcePath: redirect?.sourcePath ?? defaults?.sourcePath ?? "",
      destinationPath: redirect?.destinationPath ?? defaults?.destinationPath ?? "",
      isPermanent: redirect?.isPermanent ?? defaults?.isPermanent ?? true,
      isPattern: redirect?.isPattern ?? defaults?.isPattern ?? false,
      description: redirect?.description ?? defaults?.description ?? "",
    },
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <PaziaInput name="sourcePath" label="Ścieżka źródłowa" placeholder="/stara-strona" />
        <PaziaInput name="destinationPath" label="Ścieżka docelowa" placeholder="/nowa-strona" />
        <PaziaInput name="description" label="Opis (opcjonalny)" />
        <div className="flex items-center gap-2">
          <PaziaCheckbox name="isPattern" label="Wzorzec (placeholdery)" />
        </div>
        <p className="text-sm text-slate-500">
          Użyj {"{name}"}, aby dopasować jeden segment URL i odwołać się do niego w ścieżce docelowej. Przykład: /
          {"{slug}"} → /nowa-kat/{"{slug}"}. Użyj {"{*reszta}"}, aby dopasować wiele segmentów na raz.
        </p>
        <div className="flex items-center gap-2">
          <PaziaCheckbox name="isPermanent" label="Permanentne (301) — odznacz dla tymczasowego (302)" />
        </div>
        <PaziaFormButton title="Zapisz" className="mt-2" />
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    sourcePath: yup.string().required(),
    destinationPath: yup.string().required(),
    isPermanent: yup.boolean().required(),
    isPattern: yup.boolean().required(),
    description: yup.string().optional(),
  })
  .required();

export type ShopRedirectFormValues = yup.InferType<typeof schema>;
